<section class="content">
  <div class="card" style="padding: 25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        Route Abstract
      </div>
    </div>
    <div class="row">
      <!-- From Date Input -->
      <div class="col-3">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date" class="main-border-class" />
      </div>

      <!-- To Date Input -->
      <div class="col-3">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date" class="main-border-class" />
      </div>

      <!-- Get Button -->
      <div class="col-2">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 11%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="from_date == null || to_date == null">Get</button>
      </div>

      <!-- Spinner -->
      <div class="col-2" *ngIf="!is_document_available">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
        </mat-progress-spinner>
      </div>

      <!-- Download Button -->
      <div class="col-2" *ngIf="document_file !== null">
        <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top: 25px;">
          <i class="material-icons">picture_as_pdf</i> Download report
        </button>
      </div>
    </div>

    <!-- PDF Viewer -->
    <iframe [src]="pdf_data" width="100%" height="800" *ngIf="document_file !== null"></iframe>
  </div>
</section>